__turbopack_context__.v({
  "container": "wrapper-module__X7Tbiq__container",
  "wrapper": "wrapper-module__X7Tbiq__wrapper",
});
